/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerReprocessByFileMutationResponse, DocumentUseCasesControllerReprocessByFile400, DocumentUseCasesControllerReprocessByFile401, DocumentUseCasesControllerReprocessByFile403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerReprocessByFile";

function getDocumentUseCasesControllerReprocessByFileUrl() {
  const res = { method: 'POST', url: `/api/v1/documents/file-reprocessings` as const }  
  return res
}

/**
 * @description Finds the document associated with a file and creates a reprocessing operation. Useful when you have the file ID but not the document ID. Returns the operation resource with status and related job information.
 * @summary Create a reprocessing operation by file ID or file UUID
 * {@link /api/v1/documents/file-reprocessings}
 */
export async function documentUseCasesControllerReprocessByFile(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerReprocessByFileMutationResponse, ResponseErrorConfig<DocumentUseCasesControllerReprocessByFile400 | DocumentUseCasesControllerReprocessByFile401 | DocumentUseCasesControllerReprocessByFile403>, unknown>({ method : "POST", url : getDocumentUseCasesControllerReprocessByFileUrl().url.toString(), ... requestConfig })  
  return res.data
}